import { render } from "./UserBio.vue?vue&type=template&id=3acaec94"
import script from "./UserBio.vue?vue&type=script&lang=js"
export * from "./UserBio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__